var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLongArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 10,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#E0DEDE",
    d: "m20.28725,25.20543c0.19526,0.1952 0.51184,0.1952 0.7071,0l3.18198,-3.182c0.19527,-0.1953 0.19527,-0.5119 0,-0.7071c-0.19526,-0.1953 -0.51184,-0.1953 -0.7071,0l-2.82843,2.8284l-2.82843,-2.8284c-0.19526,-0.1953 -0.51184,-0.1953 -0.7071,0c-0.19527,0.1952 -0.19527,0.5118 0,0.7071l3.18198,3.182zm1.35355,-40.3536c0,0.55719 -0.44281,1 -1,1l0,1c1.10948,0 2,-0.89052 2,-2l-1,0zm-1,1c-0.55719,0 -1,-0.44281 -1,-1l-1,0c0,1.10948 0.89052,2 2,2l0,-1zm-0.5,0.5l0,18.5l1,0l0,-18.5l-1,0zm0,18.5l0,20l1,0l0,-20l-1,0z",
    transform: "rotate(-90 20.6408 5.10183)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowRight);
export default __webpack_public_path__ + "static/media/long-arrow-right.71fd1f665f6957b30d8ad108422d9b45.svg";
export { ForwardRef as ReactComponent };